module.exports = __webpack_public_path__ + "img/home-icon-active.93c69a39.svg";